import { Message, useWidgetStore, WidgetID } from '@/widget-store';

export function useEmitter({
  id,
  listenersPrefix,
}: {
  id: WidgetID;
  listenersPrefix: string;
}) {
  const publish = useWidgetStore((state) => state.publish);

  return (data: Message | Message[]) => {
    publish(id, Array.isArray(data) ? data : [data], listenersPrefix);
  };
}
